/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserByExternalIdTypeResponse } from './user-by-external-id-type-response';
import { UserByExternalIdStatusResponse } from './user-by-external-id-status-response';


export interface UserByExternalIdResponse { 
    id?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    login?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    externalId?: string | null;
    isBlocked?: boolean;
    status?: UserByExternalIdStatusResponse;
    type?: UserByExternalIdTypeResponse;
}

